import { useCallback } from 'react'
import type {
  TGetSocialOrdersCursorQueryParams,
  TGetSocialOrdersQueryParams,
  TSocialOrdersCursorPage,
} from '../api/types/socialOrders'
import { CURSOR_LIST_PAGE_SIZE } from '../consts/api'
import { useWindowedCursorList } from './useWindowedCursorList'

type LoadSocialOrdersPage = (
  arg: TGetSocialOrdersCursorQueryParams,
  preferCacheValue?: boolean,
) => { unwrap: () => Promise<TSocialOrdersCursorPage> }

export function useSocialOrdersWindowedPage(
  resetKey: string | number,
  loadPage: LoadSocialOrdersPage,
  queryArgs: TGetSocialOrdersQueryParams,
) {
  const fetchPage = useCallback(
    async (cursor: string | null) => {
      const data = await loadPage({ ...queryArgs, cursor, limit: CURSOR_LIST_PAGE_SIZE }, true).unwrap()
      return {
        items: data.items ?? [],
        nextCursor: data.meta?.next_cursor ?? null,
      }
    },
    [loadPage, queryArgs],
  )

  return useWindowedCursorList({
    resetKey,
    fetchPage,
  })
}
